import { RotateCcw } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useData } from "@/context/DataContext";

const Seg = ({ value, options, onChange, testid }) => (
  <div className="flex rounded-full border border-slate-700 bg-slate-900/70 p-0.5" data-testid={testid}>
    {options.map(([k, l]) => (
      <button key={k} onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
        className={`rounded-full px-2.5 py-1 text-xs transition-colors ${value === k ? "bg-slate-200 text-slate-900" : "text-slate-400 hover:text-slate-100"}`}>{l}</button>
    ))}
  </div>
);

export const FilterBar = () => {
  const { data, filters, setFilters, resetFilters } = useData();
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="global-filter-bar">
      <Select value={filters.entity || "all"} onValueChange={(v) => set("entity")(v === "all" ? null : v)}>
        <SelectTrigger className="h-8 w-[200px] rounded-full border-slate-700 bg-slate-900/70 text-xs" data-testid="filter-entity-select"><SelectValue /></SelectTrigger>
        <SelectContent className="bg-[#131c2e]">
          <SelectItem value="all" className="text-xs">All institutions (Group)</SelectItem>
          {data?.model.entities.map((e) => <SelectItem key={e.code} value={e.code} className="text-xs">{e.short}</SelectItem>)}
        </SelectContent>
      </Select>
      <Seg testid="filter-unit" value={filters.unit} onChange={set("unit")} options={[["cr", "₹ Cr"], ["lakh", "₹ Lakh"], ["pct", "%"]]} />
      <Seg testid="filter-period" value={filters.period} onChange={set("period")} options={[["annual", "Annual"], ["3yr", "3-yr"]]} />
      <button onClick={resetFilters} className="flex items-center gap-1 rounded-full px-2.5 py-1 text-xs text-slate-400 hover:text-amber-400" data-testid="filter-reset-button">
        <RotateCcw className="h-3.5 w-3.5" />Reset
      </button>
    </div>
  );
};
